import { useQuery } from "@apollo/client";
import { useLocation, useNavigate } from "react-router-dom";
import { Breadcrumb, ResponsivePrimaryNav } from "../../../components/ui";
import { FETCH_WAREHOUSE_SITES } from "../../../graphql/query/WarehouseSite";
import { hasSiteId, parseSiteId } from "../pages/SiteManagement/helpers";
import routes from "../routes";

const getSitesSection = pathname =>
  routes.find(route => pathname.split("/")[2] === route.href) || routes[0];

const PrimaryNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const section = getSitesSection(location.pathname);
  const siteId = parseSiteId(
    new URLSearchParams(location.search).get("siteId"),
  );

  const { data: { warehouseSites = [] } = {} } = useQuery(
    FETCH_WAREHOUSE_SITES,
    { skip: !hasSiteId(siteId) },
  );
  const site = warehouseSites.find(
    warehouseSite => warehouseSite.id === siteId,
  );

  const steps = [
    { label: section.name, onClick: () => navigate(`/sites/${section.href}`) },
    ...(site && section.href === "locations"
      ? [
          {
            label: site.name,
            onClick: () => navigate(`/sites/locations?siteId=${site.id}`),
          },
        ]
      : []),
  ];

  const breadcrumbProps = {
    currentStepIndex: steps.length - 1,
    onChange: index => steps[index]?.onClick(),
    steps: steps.map(step => step.label),
  };

  return (
    <ResponsivePrimaryNav>
      <div>
        <Breadcrumb {...breadcrumbProps} />
      </div>
    </ResponsivePrimaryNav>
  );
};

export default PrimaryNav;
